import sum from 'lodash/sum'
import { AnyObject, TestContext } from 'yup'

import { getParamsString } from '@helpers'

import { SectionType } from '@gantt/components/GanttCreateOrEdit'

export function validateSegmentDates(val: string | undefined, ctx: TestContext<AnyObject>) {
  const segmentItem = ctx.from?.[2]
  const segment = segmentItem?.value as SectionType

  const filledDatesCount = sum([
    Boolean(getParamsString(segment.datetimeStart)),
    Boolean(getParamsString(segment.datetimeEnd)),
    segment.duration && Boolean(getParamsString(segment.duration)),
  ])

  if (filledDatesCount >= 2) {
    return true
  }

  return !(filledDatesCount < 2 && !val)
}
